export class Str {
  private constructor(public readonly value?: string) {}

  /** @description will convert the number to string if a number is provided */
  static from(input?: string | number): Str {
    if (!input) return new Str()

    const parsedValue = String(input)
    if (!parsedValue.length || parsedValue.trim() === '') return new Str()
    return new Str(parsedValue)
  }

  get isBlank(): boolean {
    if (!this.value) return true
    if (!this.value.length) return true
    if (this.value.trim() === '') return true
    return false
  }

  get initCap(): string {
    return (this.value ?? '')
      .toLowerCase()
      .split(' ')
      .map((word: string): string => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  /** @description Returns an empty string if value is undefined */
  get val(): string {
    return this.value ?? ''
  }
}

export function truncateString(str: string, length?: number): string {
  if (!str) return ''
  const len = length ?? 15
  if (str.length <= len) return str
  return str.substring(0, len) + ' ...'
}

import DOMPurify from 'dompurify'

const HTML_MARKUP_PATTERN = /<(?:p|br|b|i|strong|em|font)\b[^>]*>/i

function normalizeHtml(raw: string): string {
  const html = raw.includes('<\\') ? raw.replace(/<\\/g, '</').replace(/<br \/?\\>/gi, '<br />') : raw

  // Parte das clipadoras manda o texto marcado (`<p>`, `<b>`, `<br />`) e parte
  // manda texto puro com a quebra de parágrafo em `\n` -- é o caso do
  // `/import` da empauta. Como o navegador colapsa `\n`, sem isto o segundo
  // grupo aparecia como um bloco único, sem parágrafo nenhum.
  //
  // A conversão vale só pro texto puro: em conteúdo já marcado o `\n` é
  // formatação entre as tags, e virar `<br />` dobraria o espaço do parágrafo.
  if (HTML_MARKUP_PATTERN.test(html)) return html

  return html.replace(/\r\n|\r|\n/g, '<br />')
}

export function sanitizePublicationHtml(raw: string): string {
  const html = normalizeHtml(raw)
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'font', 'b', 'i', 'strong', 'em'],
    ALLOWED_ATTR: ['style', 'id', 'title'],
  })
}
